import emitter from 'tiny-emitter/instance'

export default {
	$on: (...args) => emitter.on(...args),
	$once: (...args) => emitter.once(...args),
	$off: (...args) => emitter.off(...args),
	$emit: (...args) => emitter.emit(...args),
	eventNames: {
		// getMapUpdateOrderingDeckglLayers: (mapInstanceName) => {
		// 	return `ao__setDeckGlOrderingLayerMap__${mapInstanceName}`
		// },
		getNavigationRouterLinkLoading: () => {
			return 'navigationRouterLinkLoading'
		},
		getMapUpdateDeckglLayers: (mapInstanceName) => {
			return `ao__setDeckGlLayerMap__${mapInstanceName}`
		},
		getMapUpdateDeckglAnimatedLayers: (mapInstanceName) => {
			return `ao__setDeckGlAnimatedLayerMap__${mapInstanceName}`
		},
		getMapUpdateDeckglAnalyticsLayers: (mapInstanceName) => {
			return `ao__setDeckGlAnalyticsLayerMap__${mapInstanceName}`
		},
		getMapLayerClickOnPolygon: (mapInstanceName) => {
			return `ao__mapLayerClickOnPolygon__${mapInstanceName}`
		},
		getMapLayerClickOnIcon: (mapInstanceName) => {
			return `ao__mapLayerClickOnIcon__${mapInstanceName}`
		},
		getMapLayerClickOnPoint: (mapInstanceName) => {
			return `ao__mapLayerClickOnPoint__${mapInstanceName}`
		},
		getMapFitToBbox: (mapInstanceName) => {
			return `ao__mapFitToBbox__${mapInstanceName}`
		},
		getMapEaseTo: (mapInstanceName) => {
			return `ao__mapEaseTo__${mapInstanceName}`
		},
		getToggleInteractions: (mapInstanceName) => {
			return `ao__toggleInteractions__${mapInstanceName}`
		},
		getFreezeCurrentBbox: (mapInstanceName) => {
			return `ao__freezeCurrentBbox__${mapInstanceName}`
		},
		getMapZoomChanged: (mapInstanceName) => {
			return `ao__mapZoomChanged__${mapInstanceName}`
		},
		getMapLayerBitMapClick: (mapInstanceName) => {
			return `ao__mapBitMapClick__${mapInstanceName}`
		},
		getMapLayerBitMapHover: (mapInstanceName) => {
			return `ao__mapBitMapHover__${mapInstanceName}`
		},
		getMapLayerSetGlobFilterValue: (mapInstanceName) => {
			return `ao__mapLayerSetGlobFilterValue__${mapInstanceName}`
		},

		getMapInitDraw: (mapInstanceName) => {
			return `ao__initDraw__${mapInstanceName}`
		},
		getMapDrawInitialized: (mapInstanceName) => {
			return `ao__drawInitialized__${mapInstanceName}`
		},
		getMapDestroyDraw: (mapInstanceName) => {
			return `ao__destroyDraw__${mapInstanceName}`
		},
		getMapReplaceCurrentDrawArea: (mapInstanceName) => {
			return `ao__replaceCurrentDrawArea__${mapInstanceName}`
		},
		getMapDrawSave: (mapInstanceName) => {
			return `ao__drawSave__${mapInstanceName}`
		},
		getMapDrawCancel: (mapInstanceName) => {
			return `ao__drawCancel__${mapInstanceName}`
		},
		getMapDrawSavingLoading: (mapInstanceName) => {
			return `ao__drawSavingLoading__${mapInstanceName}`
		},
		getMapDrawExtraControlClick: (mapInstanceName) => {
			return `ao__drawExtraControlClick__${mapInstanceName}`
		},

		getMapAutoplaySetCursor: (mapInstanceName) => {
			return `ao__mapAutoplaySetCursor__${mapInstanceName}`
		},
		getAnalyticsChartScale: (mapInstanceName) => {//
			return `ao__analyticsChatScale__${mapInstanceName}`
		},
		getAnalyticsChartSetCursor: (mapInstanceName) => {//
			return `ao__analyticsChatSetCursor__${mapInstanceName}`
		},
		getMapTimelineScale: (mapInstanceName) => {
			return `ao__mapTimelineScale__${mapInstanceName}`
		},
		getMapTimelineSetCursor: (mapInstanceName) => {
			return `ao__mapTimelineSetCursor__${mapInstanceName}`
		},
		getMapEntityFocus: (mapInstanceName) => {
			return `ao__mapEntityFocus__${mapInstanceName}`
		},
		getMapRefreshAnalytics: (mapInstanceName) => {
			return `ao__mapRefreshAnalytics__${mapInstanceName}`
		},
		getMapRefreshTrackAnalytics: (mapInstanceName) => {
			return `ao__mapRefreshTrackAnalytics__${mapInstanceName}`
		},
		getMapCreationActionClick: (mapInstanceName) => {
			return `ao__mapCreationActionClick__${mapInstanceName}`
		},

		getMapInitialized: (mapInstanceName) => {
			return `ao__mapInitialized__${mapInstanceName}`
		},

		getMapDrawStartFinishCalculatingStrictArea: () => ('ao_mapDrawStartFinishCalculatingStrictArea'),
	},
}
